import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 85%;
  height: 85%;
  margin: auto auto;
  background-color: ${theme.colors.darkBlue};
  border-radius: ${theme.border.largeRadius};
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 10px;
    background-color: ${theme.colors.blue900};
    margin: 0 auto;
  }
`;

export const Title = styled.h1`
  color: ${theme.colors.blue100};
  text-align: center;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Text = styled.p`
  color: ${theme.colors.white};
  text-align: center;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

export const Button = styled.button`
  padding: 15px;
  height: auto;
  background-color: ${theme.colors.blue400};
  color: ${theme.colors.white};
  border: none;
  border-radius: ${theme.border.smallRadius};
  font-family: ${theme.font.poppins};
  cursor: pointer;

  @media screen and (max-width: 768px) {
    background-color: ${theme.colors.blue100};
    color: ${theme.colors.darkBlue};
    font-size: 0.8rem;
  }
`;
